import {
  uploadImage,
  updateImage,
  updateImageables,
  deleteImage,
  checkName
}                   from "../api/images"
import {
  CREATE_IMAGE,
  UPDATE_IMAGE,
  DELETE_IMAGE,
  UPDATE_IMAGEABLES,
  CHECK_IMAGE_NAME,
  REMOVE_PAGE_IMAGE,
  REMOVE_BUNDLE_IMAGE,
  REMOVE_ITEM_IMAGE,
}                   from "../mutation-types"
import sortAlphaNum from "../../utils/sortAlphaNum"

// initial state
const images = {
  namespace: 'images',
  state: {
    all: [],
    imageables: [],
  },
  getters: {
    images: (state, getters) => {
      let linkedImages = [];
      for (let imageIndex in state.all) {
        let image      = state.all[imageIndex];
        let imageables = state.imageables.filter(imageable => imageable.image_id === image.id)
        let related    = [];
        for (let x = 0; x < imageables.length; x++) {
          let imageable = imageables[x];
          if (imageable.imageable_type === 'Product') {
            /*
            let product = JSON.parse(JSON.stringify(getters.products.find(p => p.id === imageable.imageable_id)))
            related.push({ 'product': product })
             */
          }
          if (imageable.imageable_type === 'Bundle') {
            let bundle = JSON.parse(JSON.stringify(getters.bundles.find(b => b.id === imageable.imageable_id)))
            related.push({ 'bundle': bundle })
          }
        }
        let pages = JSON.parse(JSON.stringify(getters.pages.filter(page => page.image_id === image.id)));
        if (pages.length > 0) {
          for (let x = 0; x < pages.length; x++) {
            related.push({ 'page': pages[x] })
          }
        }
        linkedImages.push(Object.assign({}, image, { related }));
      }
      return linkedImages.sort((a, b) => sortAlphaNum(a.name, b.name))
    },
    imageables: (state) => state.imageables,
  },
  mutations: {
    [CREATE_IMAGE](state, image) {
      state.all.push(image)
    },
    [UPDATE_IMAGE](state, newImage) {
      let updateImage = state.all.find(image => image.id === newImage.id)
      let index       = state.all.indexOf(updateImage)
      state.all.splice(index, 1, newImage)
    },
    [UPDATE_IMAGEABLES](state, imageablePayload) {
      let oldImageables = state.imageables.filter(imageable => imageable.imageable_id === imageablePayload.imageable_id
                                                               && imageable.imageable_type ===
                                                               imageablePayload.imageable_type)
      for (let index in oldImageables) {
        state.imageables.splice(state.imageables.indexOf(oldImageables[index]), 1)
      }

      for (let index in imageablePayload.images) {
        state.imageables.push(imageablePayload.images[index])
      }
    },
    [DELETE_IMAGE](state, oldImage) {
      let deleteImage   = state.all.find(image => image.id === oldImage.id)
      let index         = state.all.indexOf(deleteImage)
      // delete imageables linked to this image
      let oldImageables = state.imageables.filter(imageable => imageable.image_id === oldImage.id)
      for (let index in oldImageables) {
        state.imageables.splice(state.imageables.indexOf(oldImageables[index]), 1)
      }
      state.all.splice(index, 1)
    },
  },

  actions: {
    [CREATE_IMAGE]: ({ commit, dispatch, state }, imageData) => {
      return new Promise((resolve, reject) => {
        uploadImage(commit, imageData)
          .then(data => {
            commit(CREATE_IMAGE, data)
            resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      })
    },
    [UPDATE_IMAGEABLES]: ({ commit, dispatch, state }, data) => {
      return new Promise((resolve, reject) => {
        updateImageables(commit, data)
          .then(data => {
            commit(UPDATE_IMAGEABLES, data)
            resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      })
    },
    [UPDATE_IMAGE]: ({ commit, dispatch, state }, data) => {
      return new Promise((resolve, reject) => {
        updateImage(commit, data)
          .then(data => {
            commit(UPDATE_IMAGE, data)
            resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      })
    },
    [DELETE_IMAGE]: ({ commit, dispatch, state }, data) => {
      return new Promise((resolve, reject) => {
        deleteImage(commit, data)
          .then(data => {
            commit(DELETE_IMAGE, data)
            commit(REMOVE_PAGE_IMAGE, data.id)
            commit(REMOVE_BUNDLE_IMAGE, data.id)
            commit(REMOVE_ITEM_IMAGE, data.id)
            resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      })
    },
    [CHECK_IMAGE_NAME]: ({ commit, dispatch, state }, data) => {
      return new Promise((resolve, reject) => {
        checkName(commit, data)
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      })
    },
  },
};

export default images;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/images/index.js
// module id = 615
// module chunks = 0